module.exports = __webpack_public_path__ + "45ae4765981f02fde58be5a98aa7ead4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Assets/momchild.png
// module id = 1322
// module chunks = 0